<template>
  <header>
    <div class="container">
      <nav class="navbar">
        <a
          href="#"
          class="logo"
        >
          <img
            src="/images/logo.png"
            alt="E3"
            class="logo-icon"
          >
          DesignPulse
        </a>
        <div class="nav-links">
          <a href="#pain-points">市场痛点</a>
          <a href="#features">解决方案</a>
          <a href="#workflow">设计流程</a>
          <a href="#research">技术成果</a>
          <a href="#team">团队</a>
          <a href="#vision">未来愿景</a>
        </div>
        <div class="nav-buttons">
          <button
            class="btn"
            :class="isLoggedIn ? 'btn-logged-in' : 'btn-outline'"
            :disabled="isLoggedIn"
            @click="handleLogin"
          >
            {{ isLoggedIn ? "已登录" : "登录" }}
          </button>
          <button
            class="btn btn-primary"
            @click="handleFreeTrial"
          >
            免费试用
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted } from "vue";
import localStorageTools from "@/utils/localStorageTool";

const activeIndex = ref("2");
const isLoggedIn = ref(false);

const handleSelect = (key) => {
};

const handleFreeTrial = () => {
  // ✅ 检查登录状态
  const logToken = localStorageTools.getValueWithExpiry("logToken");
  if (!logToken) {
    // 未登录，先跳转登录，登录后进入系统
    window.location.href = "/login.html?redirect=%2Fmain";
  } else {
    // 已登录，直接跳转
    window.location.href = "/main/";
  }
};

const handleLogin = () => {
  const logToken = localStorageTools.getValueWithExpiry("logToken");
  const isLoginPage = window.location.pathname.endsWith("login.html");
  if (!logToken && !isLoginPage) {
    window.location.href = "/login.html";
  }
};
onMounted(() => {
  checkLoginStatus();
});

const checkLoginStatus = () => {
  const logToken = localStorageTools.getValueWithExpiry("logToken");
  isLoggedIn.value = !!logToken;
};
</script>

<style scoped>
header {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: var(--transition);
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 800;
  font-size: 1.8rem;
  color: var(--secondary);
  text-decoration: none;
}

.logo-icon {
  width: 58px;
  height: 43px;
  display: block;
  object-fit: contain;
}

.nav-links {
  display: flex;
  gap: 35px;
}

.nav-links a {
  text-decoration: none;
  color: var(--secondary);
  font-weight: 600;
  font-size: 1.1rem;
  transition: var(--transition);
  position: relative;
  padding: 5px 0;
}

.nav-links a:hover {
  color: var(--accent-500);
}

.nav-links a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: var(--primary);
  transition: var(--transition);
  border-radius: 3px;
}

.nav-links a:hover::after {
  width: 100%;
}

.nav-buttons {
  display: flex;
  gap: 15px;
}

.btn {
  padding: 14px 28px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 1.1rem;
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.btn-outline {
  background: transparent;
  border: 2px solid var(--primary);
  color: var(--primary);
}

.btn-outline:hover {
  background: var(--primary);
  color: white;
  transform: translateY(-3px);
}

.btn-primary {
  background: var(--gray-600);
  color: white;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.4);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(37, 99, 235, 0.5);
}

.btn-accent {
  background: var(--accent);
  color: white;
  box-shadow: 0 10px 25px rgba(139, 92, 246, 0.4);
}

.btn-accent:hover {
  background: #7c3aed;
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(139, 92, 246, 0.5);
}

.btn-logged-in {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  cursor: not-allowed !important;
  border-color: #e0e0e0 !important;
  box-shadow: none !important;
}

.btn-logged-in:hover {
  transform: none !important;
  background-color: #e0e0e0 !important;
}
</style>
